// extracted by mini-css-extract-plugin
export var faqContainer = "FAQ-module--faqContainer--9Ry28";
export var faqdesktopH1 = "FAQ-module--faqdesktopH1--40lhT";
export var faqheaderTitle = "FAQ-module--faqheaderTitle--scw5W";
export var faqitems = "FAQ-module--faqitems--Bwznw";
export var faqmobileH1 = "FAQ-module--faqmobileH1--Nsrrn";
export var viewAllFaqButton = "FAQ-module--viewAllFaqButton--mo+gH";